export default __webpack_public_path__ + "static/media/message-img.b1e61925.jpeg";